import { AccessorsMutatorsDecorator, Model } from '../../helpers';
import { TranslatableModel } from './translatable-model';

export class SubscriptionSetting extends TranslatableModel {

    static get validationModel() {

        return {
            discount_value: {
                messages: {
                    required: 'SELECT_DISCOUNT_REQUIRED'
                }
            },
            period_length: {
                messages: {
                    required: 'LENGTH_EXT_PERIOD_REQUIRED'
                }
            },
        };
    }
}

AccessorsMutatorsDecorator('id', 'enable_discount', 'discount_value', 'period_length')(SubscriptionSetting);



// WEBPACK FOOTER //
// ./src/pms-api/models/subscription-setting.model.js